var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.2,
    height: 19.55,
    viewBox: "8.983 6.983 16.2 19.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.022 9.346h-2.535v-.189c0-1.186-.97-2.157-2.157-2.157h-2.48c-1.187 0-2.158.97-2.158 2.157v.189h-2.535c-1.186 0-2.157.97-2.157 2.157v.593c0 .971.674 1.807 1.564 2.077v8.844a3.499 3.499 0 0 0 3.505 3.506h6.04a3.499 3.499 0 0 0 3.506-3.506v-8.871c.89-.27 1.564-1.079 1.564-2.077v-.593c0-1.16-.97-2.13-2.157-2.13Zm-8.251-.189c0-.593.485-1.078 1.078-1.078h2.481c.593 0 1.079.485 1.079 1.078v.189H14.77v-.189Zm5.339 16.287h-6.04a2.417 2.417 0 0 1-2.427-2.427v-8.763h10.894v8.763c0 1.322-1.106 2.427-2.427 2.427Zm3.99-13.348c0 .594-.485 1.08-1.078 1.08H11.157a1.082 1.082 0 0 1-1.078-1.08v-.593c0-.593.485-1.078 1.078-1.078h11.865c.593 0 1.079.485 1.079 1.078v.593Z",
    fill: "#333",
    fillRule: "evenodd",
    "data-name": "Path 49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.68 16.474v5",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#333",
    fill: "transparent",
    "data-name": "Line 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.68 16.474v5",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#333",
    fill: "transparent",
    "data-name": "Line 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.09 16.474v5",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#333",
    fill: "transparent",
    "data-name": "Line 5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.c977d85d1adfb0f45e8429d8ae4da1d4.svg";
export { ForwardRef as ReactComponent };